import { Component, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IconComponent } from "@rig/ng-media";

@Component({
  selector: "static-footer",
  templateUrl: "./static-footer.component.html",
  styleUrls: ["./static-footer.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, IconComponent]
})
export class StaticFooterComponent {
  year = new Date().getFullYear();
}
